<template>
  <div class="tabs-wrapper">
    <div class="tab flex text-center">
    <v-select
      class="select-field-no-underline font-size-medium-large  my-2"
      v-model="brand"
      text="text"
      value="value"
      color="white"
      :items="brands">
      <template v-slot:selection="{ item }">
        <span class="d-flex justify-center white--text" style="width: 100%;">
          {{ item.text }}
        </span>
      </template>
      <template v-slot:append>
        <div>
          <v-icon class="cvc-actions-white-arrow">
            mdi-arrow-down-thick
          </v-icon>
        </div>
      </template>
    </v-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "CvcActions",
  computed: {
    brand: {
      get() {
        return this.$store.state.dailyCounts.brand;
      },
      set(brand) {
        return this.$store.dispatch('getDailyCounts', {brand: brand})
      }
    },
    brands() {
      return this.$store.state.dailyCounts.brands.map(b => {
        return {
          text: b.name,
          value: b
        }
      });
    },
  },
}
</script>

<style scoped lang="scss">
  .tabs-wrapper {
    position: absolute;
    top: 0;
    right: 0;
  }
  .tab {
    margin: 0 0 0 0px;
    height: 66px;
    width: 250px;
    padding: 10px 16px 14px 16px;
    color: white !important;
    border: #E97DF2;
    border-width: 20px;
    background-color: #E97DF2 !important;
    &:before {
      color: white !important;
      background-color: #E97DF2 !important;
    }
  }
  .cvc-actions-white-arrow {
    color: white;
    font-size: 16px;
    padding-top: 2px;
    padding-right: 4px;
  }
</style>